import Repository from "../Repository";

const resource = "/sites";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getAdServerSites(){
        return Repository.get(`/adserver${resource}`);
    },
    getSecondLevelAdServerSites(parentId){
        return Repository.get(`/adserver/secondlevelsites/${parentId}`);
    },
    getSite(siteId){
        return Repository.get(`${resource}/${siteId}`);
    },
    createSite(json){
        return Repository.post(`${resource}`,json);
    },
    updateSite(siteId,json){
        return Repository.put(`${resource}/${siteId}`,json);
    },
    deleteSite(siteId){
        return Repository.delete(`${resource}/${siteId}`);
    },
    validateSite(name){
        return Repository.get(`${resource}/validate/${name}`);
    },
    getResource(){
        return resource;
    }
}